module.exports = __webpack_public_path__ + "img/check_in-out4.69d9f4cc.png";